export default function arrayOf(count: number) {
  return [...new Array(count).keys()]
}
